import React, { useEffect } from 'react';
import { FormContainer, FormInput, Text } from '@thecb/components';
import { hasLength } from 'redux-freeform';
import {
  returnFormReducer,
  returnFormMapStateToProps,
  returnFormMapDispatchToProps,
} from './OrderDetailsReturnModal.state';

const notesErrors = {
  [hasLength.error]: 'Character limit exceeded (250)',
};

const ReturnForm = ({ actions, fields }) => {
  useEffect(() => {
    return () => actions.form.clear();
  }, []);
  return (
    <FormContainer>
      <Text>Are you sure you want to refund this order?</Text>
      <hr />
      <FormInput
        data-testid="Notes Test"
        labelTextWhenNoError="Notes"
        field={fields.notes}
        fieldActions={actions.fields.notes}
        errors={fields.errors}
        errorMessages={notesErrors}
        labelTextVariant="p"
        errorTextVariant="p"
      />
    </FormContainer>
  );
};

ReturnForm.reducer = returnFormReducer;
ReturnForm.mapStateToProps = returnFormMapStateToProps;
ReturnForm.mapDispatchToProps = returnFormMapDispatchToProps;

export { ReturnForm };
